module.exports = {
	/**
	 * If you change the configurations,
	 * don't forget to rebuild the code (npm run build) and
	 * restart the server (npm run start).
	 */
	locales: ['en', 'fi', 'ca', 'de'],
	projects: [
		// make sure the ids are 'String' type
		{ id: 'casinobud', name: 'Casinobud' },
		{ id: 'budsino', name: 'Budsino' },
		/*{ id: 'pikakasino', name: 'Pikakasino' },
		{ id: 'rocketcasino', name: 'Rocket Casino' },
		{ id: 'kiirkasiino', name: 'Kiirkasiino' },
		{ id: 'bataviacasino', name: 'Batavia Casino' },*/
	],
	enableNotifications: true,
};
